import Cookies from "js-cookie";
import React, { createContext, useCallback, useContext, useState } from "react";
import { User } from "../models/User";
import { useKeycloak } from "./keycloak";

interface AuthContextInterface {
  loggedUser?: User;
  token?: string;
  userChecked?: boolean;
  setLoggedUser: React.Dispatch<React.SetStateAction<User | undefined>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  setUserChecked: React.Dispatch<React.SetStateAction<boolean>>;
  newNotifications?: number;
  logout: VoidFunction;
  setNewNotifications: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const AuthContext = createContext<AuthContextInterface>({} as AuthContextInterface);

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  const { keycloak } = useKeycloak();
  const tokenCookie = Cookies.get(window.__env.AUTH_TOKEN_NAME || "alida-token");
  const userCheckedCookie = Cookies.get(window.__env.AUTH_USER_CHECKED_NAME || "alida-user-checked") === "true";
  const [loggedUser, setLoggedUser] = useState<User>();
  const [token, setToken] = useState<string | undefined>(tokenCookie);
  const [userChecked, setUserChecked] = useState<boolean>(userCheckedCookie);
  const [newNotifications, setNewNotifications] = useState<number | undefined>();

  const logout = useCallback(() => {
    Cookies.remove(window.__env.AUTH_TOKEN_NAME || "alida-token");
    Cookies.remove(window.__env.AUTH_REFRESH_TOKEN_NAME || "alida-refresh-token");
    Cookies.remove(window.__env.AUTH_USER_NAME || "alida-user");
    Cookies.remove(window.__env.AUTH_USER_CHECKED_NAME || "alida-user-checked");
    sessionStorage.removeItem(`${window.__env.AI_CHAT__SESSION_PREFIX || "alida-chat-session"}_open`);
    sessionStorage.removeItem(`${window.__env.AI_CHAT__SESSION_PREFIX || "alida-chat-session"}_state`);
    // Cookies.remove(window.__env.AI_CHAT__SESSION_PREFIX || "alida-chat-session");
    keycloak.logout({ redirectUri: window.__env.POST_LOGOUT_REDIRECT_URI });
  }, [keycloak]);

  return (
    <AuthContext.Provider value={{
      loggedUser, token, setLoggedUser, setToken,
      userChecked, setUserChecked, logout,
      newNotifications, setNewNotifications,
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);
